import React from 'react';
import { useConnect } from 'redux-bundler-hook';

const Router = () => {
  const { route: Component } = useConnect('selectRoute');
  return <Component />;
};

export default Router;
